// extracted by mini-css-extract-plugin
export default {"mainContainer":"OptionCapsules_mainContainer__-UJnw","active":"OptionCapsules_active__p9wMb"};